import React from "react"
import { Link } from "gatsby"
import { useLocation } from "@reach/router"
import "../../styles/outcome-section.scss"

const normalizePath = (p = "") => {
  const s = p.startsWith("/") ? p : `/${p}`
  return s.endsWith("/") && s !== "/" ? s.slice(0, -1) : s
}

export const OutcomeCard = ({
  logo,
  logoAlt,
  logoScale,
  tag,
  title,
  description,
  gradient,
  href,
}) => {
  const { pathname } = useLocation()
  const logos = Array.isArray(logo) ? logo : [logo].filter(Boolean)
  const normalizedHref = href ? normalizePath(href) : null

  const handleClick = e => {
    if (!normalizedHref) return
    const current = normalizePath(pathname)
    if (current === normalizedHref) {
      e.preventDefault()
      if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
    }
  }

  const CardContent = (
    <div
      className="outcome-card"
      style={{
        background: gradient,
        cursor: normalizedHref ? "pointer" : "default",
      }}
    >
      <div className="card-header">
        {logos.map((src, i) => (
          <span
            key={i}
            style={
              logoScale != null && logoScale !== 1
                ? {
                    transform: `scale(${logoScale})`,
                    transformOrigin: "bottom right",
                  }
                : undefined
            }
          >
            <img src={src} alt={`${logoAlt || "Logo"} ${i + 1}`} />
          </span>
        ))}
        {tag && <span className="tag">{tag}</span>}
      </div>

      <div className="card-content">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  )

  return normalizedHref ? (
    <Link
      to={normalizedHref}
      onClick={handleClick}
      className="outcome-card-link"
      style={{ textDecoration: "none", color: "inherit" }}
    >
      {CardContent}
    </Link>
  ) : (
    <div className="outcome-card-link">{CardContent}</div>
  )
}
